/* Extracts domain with no http and no query - just clear domain */
function extractDomain(url) {
    var domain;
    // find & remove protocol (http, ftp, etc.) and get domain
    if (url.indexOf('://') > -1) {
        domain = url.split('/')[2];
    }
    else {
        domain = url.split('/')[0];
    }
    // find & remove port number
    domain = domain.split(':')[0];

    return domain;
}

export function incomingMessage(messageEvent) {
    if (document.getElementById('supportFrame') === null) {
        return;
    }

    if (messageEvent.origin.indexOf(extractDomain(document.getElementById('supportFrame').src)) === -1) {
        return;
    }

    if (!(messageEvent.data)) {
        return;
    }
    switch (messageEvent.data.messageType) {
        case 'changeIframeSize':
            document.getElementById('supportFrame').style.height = `${messageEvent.data.height}px`;
            break;
        default:
            break;
    }
}
